export type NavItem = {
  id: string;
  label: string;
  short: string;
  path: string;
};

export const navigation: NavItem[] = [
  { id: 'overview', label: 'Overview', short: '01', path: '/' },
  { id: 'devices', label: 'Devices', short: '02', path: '/devices' },
  { id: 'screens', label: 'Screens', short: '03', path: '/screens' },
  { id: 'schedule', label: 'Schedule', short: '04', path: '/schedule' },
  { id: 'layouts', label: 'Layouts', short: '05', path: '/layouts' },
  { id: 'media', label: 'Media', short: '06', path: '/media' },
  { id: 'deployments', label: 'Deployments', short: '07', path: '/deployments' },
  { id: 'submissions', label: 'Submissions', short: '08', path: '/submissions' },
  { id: 'integrations', label: 'Integrations', short: '09', path: '/integrations' },
  { id: 'data-sources', label: 'Data sources', short: '10', path: '/data-sources' },
  { id: 'settings', label: 'Settings', short: '11', path: '/settings' }
];
